import React, { Component } from 'react';
import Style from 'components/mgm/GiftCard.module.scss';

export default class GiftCard extends Component {
  render() {
    return (
      <main>
        <div className={Style['number']}>{this.props.number}</div>
        <section
          style={{ backgroundColor: this.props.backgroundColor }}
          className={Style['wrapper']}
        >
          <img src={this.props.img} alt="produto da promoção" />
          <p className={Style['text']}>{this.props.text}</p>
        </section>
      </main>
    );
  }
}
